import { render, staticRenderFns } from "./DetailTitle.vue?vue&type=template&id=c34b6286&scoped=true"
import script from "./DetailTitle.vue?vue&type=script&lang=js"
export * from "./DetailTitle.vue?vue&type=script&lang=js"
import style0 from "./DetailTitle.vue?vue&type=style&index=0&id=c34b6286&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@5.2.7_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34b6286",
  null
  
)

export default component.exports